import React from 'react';
import { KTSVG } from '../../_metronic/helpers';
import '../textFields/TextField.css'

interface Props {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    placeholder: string;
    className?: string;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void; // Update this line
    mainClassName?: any
}

const SearchBarComponent: React.FC<Props> = ({ value, placeholder, onChange, className = 'w-250px', onKeyUp, mainClassName }) => {
    return (
        <div className={`d-flex align-items-center position-relative ${mainClassName ?? 'my-1'} ss-table-search`}>
            <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute start-0 ms-3 ss-table-search-icon'
            />
            <input
                type='text'
                data-kt-user-table-filter='search'
                className={`${className} form-control form-control-solid default-input ss-table-search-input ps-10`}
                placeholder={`Search ${placeholder}...`}
                value={value}
                onChange={onChange}
                onKeyUp={onKeyUp}
            />
        </div>
    );
};

export default SearchBarComponent;
